import { Injectable, ViewChild } from "@angular/core";
import { HttpHeaders } from '@angular/common/http';
import { Nav } from 'ionic-angular';
import { Observable } from "rxjs/Observable";
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';

import { User } from '../../models/user.model';
import { Api } from "../util/api";
import { AuthLocalService } from '../util/auth-local.service';

@Injectable()
export class LoginService {
  private endpoint = 'login';
  @ViewChild(Nav) nav: Nav;

  constructor(private api: Api,
              private authLocalService: AuthLocalService) {
  }

  login(email, password): Observable<User> {
    const authHeader = 'Basic ' + btoa(email + ':' + password);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
      .append('Authorization', authHeader);
    const options = {
      headers: headers
    };
    let body = {
      email: email,
      password: password,
    };
    return this.api.put(this.endpoint, body, options)
      .map((user: User) => {
        this.authLocalService.setAuthHeader(authHeader);
        this.authLocalService.setCurrentUser(user);
        return user;
      });
  }

  logout(): Observable<any> {
    return forkJoin(
      of(this.authLocalService.removeCurrentUser()),
      of(this.authLocalService.removeAuthHeader())
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/login.service.ts